export const FILE_PANEL = 'file';
export const FILTERS_PANEL = 'filters';
export const FOLDER_SETTINGS = 'folder-settings';
export const ITEM_KITS = 'item-kits';
export const CALENDAR_FILTERS = 'calendar-filters';
export const PROJECT_NOTIFICATIONS = 'project-notifications';
export const WORKSPACE_TEAMS = 'workspace-teams';
export const NONE = 'none';
